import React from 'react';
import { Needs, TaxconForm, Industry, VafContactForm } from './steps/index.js';
import axios from '../../shared/axios/axiosProxy.js';
import './vafFlow.scss';
import i18n from '../../utils/i18n.js';
import { withTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import peaking1 from '../../images/peaking.png';
import peaking2 from '../../images/peaking2.png';
import peaking3 from '../../images/peaking3.png';
import peaking4 from '../../images/peaking4.png';
import rocketman from '../../images/Rocketman.png';
import blueaccountant from '../../images/BlueAccountant.png';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import VacationNotice from '../../shared/components/vacationNotice/VacationNotice.jsx';
//REDUX
import ACTIONS, {
	fetchAspPotentialProviders,
	fetchCherryPotentialProviders,
} from '../../redux/action.js';
import { connect } from 'react-redux';
import { checkStateChange } from './data/searchFlowText.js';

const mapStateToProps = (state) => ({
	store: state,
	loading: state.loading,
	company_store: state.company_store,
	match_score_weights: state.match_score_weights,
	potential_providers: state.company_store.potential_providers,
});
const mapDispatchToProps = (dispatch) => ({
	addCompanyInfo: (item) => dispatch(ACTIONS.addCompanyInfo(item)),
	fetchAspPotentialProviders: (companyData, msWeights) =>
		dispatch(fetchAspPotentialProviders(companyData, msWeights)),
	fetchCherryPotentialProviders: (companyData, msWeights) =>
		dispatch(fetchCherryPotentialProviders(companyData, msWeights)),
});
class VafFlow extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			activeStep: 0,
			reqID: '',
			cherryID: '',
			searchID: '',
			completedSteps: 0,
			kNetPlusSent: false,
			helpForm: false,
			stepData: `1 - ${new Date().toLocaleTimeString(
				i18n.t('general.countryformat'),
				{
					hour12: false,
				}
			)}`,
			viewedProviders: [],
			vacatiOn: false,
			bookkeepie_id: Cookies.get('bookkeepie_id') || null,
			utm_source: '',
			utm_medium: '',
			utm_campaign: '',
			utm_content: '',
			utm_term: '',
			gclid: '',
			dclid: '',
		};
	}

	dataLayerUpdate(stepData, event) {
		window.dataLayer.push({
			event: event,
			step: stepData,
			event_category: 'vafflow',
		});
	}

	bkIdDataLayerUpdate(stepData, event) {
		window.dataLayer.push({
			event: event,
			bookkeepie_id: stepData,
			event_category: 'vafflow',
		});
	}

	dataLayerVersionUpdate() {
		window.dataLayer.push({
			event: 'sf_step_A/B_testing',
			version: 'A',
			event_category: 'vafflow',
		});
	}

	componentDidMount() {
		let bkID = Cookies.get('bookkeepie_id');

		// Ha van searchID a Redux store-ban, használjuk azt
		if (
			this.props.company_store.searchID &&
			this.props.company_store.searchID !== ''
		) {
			this.setState({ searchID: this.props.company_store.searchID });
		} else if (this.state.searchID === '') {
			this.submitSearchData();
		}
		if (!bkID) {
			bkID = uuidv4();
			this.setState({ bookkeepie_id: bkID });
			Cookies.set('bookkeepie_id', bkID, { expires: 90 });
			this.props.addCompanyInfo({
				id: 'searchUser',
				data: bkID,
				stateObject: 'company_store',
			});
			axios
				.post(
					`/api/searchUser`,
					{
						userID: bkID,
						searches: [],
						reqs: [],
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then((response) => {
					console.log('AXIOS RESPONSE: ', response);
				})
				.catch((error) => {
					console.log('AXIOS ERROR: ', error.response.data);
				});
		} else {
			this.props.addCompanyInfo({
				id: 'searchUser',
				data: bkID,
				stateObject: 'company_store',
			});
		}
		this.bkIdDataLayerUpdate(bkID, 'sf_step_bookkeepie_id');
		this.dataLayerUpdate(this.state.activeStep, 'sf_step_changed');
		this.dataLayerVersionUpdate();
		this.props.addCompanyInfo({
			id: 'abVersion',
			data: 'A',
			stateObject: 'company_store',
		});

		let cookie = document.cookie;
		if (!cookie.includes('reqsent')) {
			document.cookie = 'reqsent=false';
		}

		if (!this.props.company_store.utm_source) {
			const urlParams = new URLSearchParams(window.location.search);
			const utm_source = urlParams.get('utm_source') || '';
			const utm_medium = urlParams.get('utm_medium') || '';
			const utm_campaign = urlParams.get('utm_campaign') || '';
			const utm_content = urlParams.get('utm_content') || '';
			const utm_term = urlParams.get('utm_term') || '';
			const gclid = urlParams.get('gclid') || '';
			const dclid = urlParams.get('dclid') || '';

			this.setState({
				utm_source,
				utm_medium,
				utm_campaign,
				utm_content,
				utm_term,
				gclid,
				dclid,
			});

			this.props.addCompanyInfo({
				id: 'utm_source',
				data: utm_source,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'utm_medium',
				data: utm_medium,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'utm_campaign',
				data: utm_campaign,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'utm_content',
				data: utm_content,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'utm_term',
				data: utm_term,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'gclid',
				data: gclid,
				stateObject: 'company_store',
			});
			this.props.addCompanyInfo({
				id: 'dclid',
				data: dclid,
				stateObject: 'company_store',
			});
		}

		if (!this.props.company_store.companytype) {
			const urlParams = new URLSearchParams(window.location.search);
			const urlCompanytype = urlParams.get('companytype');

			if (urlCompanytype === 'bt' || urlCompanytype === 'kft') {
				this.props.addCompanyInfo({
					id: 'anwser',
					data: 'founding',
					stateObject: 'company_store',
				});
				this.props.addCompanyInfo({
					id: 'newlyfounded',
					data: true,
					stateObject: 'company_store',
				});
				this.props.addCompanyInfo({
					id: 'legalentityfounding',
					data: true,
					stateObject: 'company_store',
				});
				this.props.addCompanyInfo({
					id: 'companytype',
					data: urlCompanytype,
					stateObject: 'company_store',
				});
			}
		}

		if (this.props.company_store.utm_source) {
			this.setState({
				utm_source: this.props.company_store.utm_source || '',
				utm_medium: this.props.company_store.utm_medium || '',
				utm_campaign: this.props.company_store.utm_campaign || '',
				utm_content: this.props.company_store.utm_content || '',
				utm_term: this.props.company_store.utm_term || '',
				gclid: this.props.company_store.gclid || '',
				dclid: this.props.company_store.dclid || '',
			});
		}

		if (this.props.company_store.activeStep !== 0) {
			this.setState({ activeStep: 1 });
		}
	}
	componentDidUpdate(_prevProps, prevState) {
		this.handleSearchUpdate(prevState.activeStep);
		let bkID = Cookies.get('bookkeepie_id');
		if (bkID) {
			let searchList = [];
			axios
				.get(`/api/searchUser/${bkID}`, {
					headers: {
						'Content-Type': 'application/json',
					},
				})
				.then((response) => {
					searchList = response.data.searchUser.searches.filter(
						(value) => value !== null
					);
					if (
						!searchList.includes(
							this.state.searchID &&
								this.state.searchID !== null &&
								this.state.searchID !== ''
						)
					) {
						searchList.push(this.state.searchID);
						let uniques = [
							...new Set(searchList.filter((item) => item.trim() !== '')),
						];
						axios.patch(
							`/api/searchUser/${bkID}`,
							{ searches: uniques },
							{
								headers: {
									'Content-Type': 'application/json',
								},
							}
						);
					}
				})
				.catch((error) => {
					console.log('AXIOS ERROR COMPUPDATE: ', error.response);
				});
		}
		if (
			this.state.completedSteps >= 14 &&
			checkStateChange(_prevProps.company_store, this.props.company_store) ===
				true
		) {
			this.props.fetchAspPotentialProviders(
				this.props.company_store,
				this.props.match_score_weights
			);
		}
		if (
			this.state.completedSteps >= 15 &&
			this.state.reqID.length > 0 &&
			checkStateChange(_prevProps.company_store, this.props.company_store)
		) {
			this.props.addCompanyInfo({
				id: 'selected_providers',
				data: [],
				stateObject: 'company_store',
			});
		}
	}

	handleNext = (increment = 1) => {
		if (this.state.activeStep <= 15) {
			if (this.state.searchID === '') {
				this.submitSearchData();
			}
			this.setState({
				activeStep: this.state.activeStep + increment,
			});
			this.dataLayerUpdate(
				this.state.activeStep + increment,
				'sf_step_changed'
			);
			if (this.state.completedSteps < this.state.activeStep) {
				this.setState({
					completedSteps: this.state.completedSteps + increment,
				});
			}
		}
		window.scrollTo(0, 0);
	};
	handleBack = (decr = 1) => {
		if (this.state.activeStep !== 0) {
			this.setState({ activeStep: this.state.activeStep - decr });
		}
		window.scrollTo(0, 0);
	};

	submitSearchData = () => {
		let data = this.props.company_store;
		data.step = this.state.activeStep + 1;
		data.time = this.state.stepData;
		data.returnedProviders = 0;
		data.screenWidth = `${window.innerWidth}`;
		data.lang = this.props.company_store.chosenLanguage;
		data.leadtype = 'VAF';
		data.flowStart = this.props.company_store.flowStart || 'VAF';
		data.utm_source = this.state.utm_source;
		data.utm_medium = this.state.utm_medium;
		data.utm_campaign = this.state.utm_campaign;
		data.utm_content = this.state.utm_content;
		data.utm_term = this.state.utm_term;
		data.gclid = this.state.gclid;
		data.dclid = this.state.dclid;
		data.abVersion = this.props.company_store.abVersion || 'A';

		if (this.state.searchID) {
			axios
				.patch(
					`/api/search/${this.state.searchID}`,
					{
						leadtype: 'VAF',
						flowStart: this.props.company_store.flowStart || 'VAF',
						abVersion: this.props.company_store.abVersion || 'A',
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then((response) => {
					console.log('Search updated: ', response.statusText);
				})
				.catch((error) => {
					console.log('AXIOS ERROR updating search: ', error.response.data);
				});
		} else {
			axios
				.post(`/api/search`, data, {
					headers: {
						'Content-Type': 'application/json',
					},
				})
				.then((response) => {
					console.log('AXIOS RESPONSE: ', response.statusText);
					this.setState({ searchID: response.data.result._id });
					response.data.result._id &&
						this.props.addCompanyInfo({
							id: 'searchID',
							data: response.data.result._id,
							stateObject: 'company_store',
						});
				})
				.catch((error) => {
					console.log('AXIOS ERROR: ', error.response.data);
				});
		}
	};

	updateSearchData = (time) => {
		let data = this.props.company_store;
		const timeValue = time ?? this.state.stepData;
		data.lang = this.props.company_store.chosenLanguage;
		if (!this.state.requestSent) {
			data.step = this.state.activeStep + 1;
		}
		data.time = timeValue;
		data.reqID = this.state.reqID;
		data.abVersion = this.props.company_store.abVersion || 'A';
		data.distanceWeight = this.props.store.match_score_weights.distanceWeight;
		data.priceWeight = this.props.store.match_score_weights.priceWeight;
		data.reviewWeight = this.props.store.match_score_weights.reviewWeight;
		data.phoneWeight = this.props.store.match_score_weights.phoneWeight;
		data.availabilityWeight =
			this.props.store.match_score_weights.availabilityWeight;
		data.experienceWeight =
			this.props.store.match_score_weights.experienceWeight;
		data.liabilityInsWeight =
			this.props.store.match_score_weights.liabilityInsWeight;
		data.badgeWeight = this.props.store.match_score_weights.badgeWeight;
		if (
			this.props.potential_providers !== undefined &&
			this.props.potential_providers.constructor === Object &&
			this.props.potential_providers.some((e) => e.length !== 0)
		) {
			let rPCounter = 0;
			this.props.potential_providers.forEach((e) => {
				rPCounter += e.length;
			});

			data.returnedProviders = rPCounter;
			let tempArray = [[], [], []];
			for (let i in this.props.potential_providers) {
				for (let j in i) {
					tempArray[i].push(this.props.potential_providers[i][j].companyname);
				}
			}
			data.providers = tempArray;
		}
		axios
			.patch(`/api/search/${this.state.searchID}`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response.statusText);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};

	handleSearchUpdate = (prevStep) => {
		if (this.state.activeStep !== prevStep) {
			let timeString = this.state.stepData.concat(
				`, ${this.state.activeStep + 1} - ${new Date().toLocaleTimeString(
					'hu-HU',
					{
						hour12: false,
					}
				)}`
			);
			this.setState({
				stepData: timeString,
			});
			if (this.state.activeStep !== 1) {
				this.updateSearchData(timeString);
			}
		}
		if (prevStep === 'tableUpdate') {
			this.updateSearchData(this.state.stepData);
		}
	};

	stepperCounter = {
		0: 0,
		1: 1,
		2: 2,
		3: 3,
	};

	headerText = {
		0: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext1')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext1a')}</p>
			</div>
		),
		1: (
			<div>
				<p className="headerSubText"></p>
				<p className="headerText">{i18n.t('searchflow.vaflabel')}</p>
			</div>
		),
		2: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext3b')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext3c')}</p>
			</div>
		),
		3: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.sfresulttext2')}</p>
				<p className="headerText">{i18n.t('searchflow.whatnowtext2')}</p>
			</div>
		),
	};
	imageSource = {
		0: peaking1,
		1: peaking2,
		2: peaking3,
		3: peaking4,
	};

	getStepContent = (step) => {
		switch (step) {
			case 0: {
				return <Needs handleNext={this.handleNext} />;
			}
			case 1: {
				return (
					<Industry handleNext={this.handleNext} handleBack={this.handleBack} />
				);
			}
			case 2: {
				return (
					<TaxconForm
						handleNext={this.handleNext}
						handleBack={this.handleBack}
					/>
				);
			}
			case 3: {
				return (
					<VafContactForm
						handleBack={this.handleBack}
						onRequestSent={this.handleSearchRequestSent}
					/>
				);
			}
			default:
				return i18n.t('general.notfound');
		}
	};

	handleSearchRequestSent = () => {
		const timeStamp = this.state.stepData.concat(
			` Req sent - ${new Date().toLocaleTimeString(
				i18n.t('general.countryformat'),
				{
					hour12: false,
				}
			)}`
		);
		this.setState({ stepData: timeStamp }, () =>
			this.updateSearchData(timeStamp)
		);
		this.updateSearchRfpsent();
	};

	updateSearchRfpsent = () => {
		if (!this.state.searchID) {
			return;
		}
		const rfpsentDate = new Date();
		axios
			.patch(
				`/api/search/${this.state.searchID}`,
				{ rfpsent: rfpsentDate },
				{
					headers: {
						'Content-Type': 'application/json',
					},
				}
			)
			.then((response) => {
				console.log('rfpsent saved to searchSchema:', response.statusText);
			})
			.catch((error) => {
				console.error(
					'Error saving rfpsent to searchSchema:',
					error.response?.data || error.message
				);
			});
	};

		render() {
			return (
				<>
					<VacationNotice />
					<div className={'VFContainer'}>
				{this.state.activeStep !== 15 && this.state.activeStep !== 16 && (
					<div className="VFLeftInfoArea">
						<img src={rocketman} alt="RocketMan" className="rocketman" />
					</div>
				)}
				<div
					className={`${
						this.state.activeStep !== 15 && this.state.activeStep !== 16
							? 'VFContentArea'
							: 'VFOfferArea'
					}`}>
					{this.state.activeStep !== 15 && this.state.activeStep !== 16 && (
						<div className="VFContentHeader">
							<div>{this.headerText[this.state.activeStep]}</div>

							<div>
								<img
									className="headerImg"
									alt="header"
									src={this.imageSource[this.state.activeStep]}
								/>
							</div>
						</div>
					)}

					<div style={{ 'overflow-y': 'auto' }}>
						{this.getStepContent(this.state.activeStep)}
					</div>
				</div>
				{this.state.activeStep !== 15 && this.state.activeStep !== 16 && (
					<div className="VFRightInfoArea">
						<img
							src={blueaccountant}
							alt="Accountant lady"
							className="blueaccountant"
						/>
					</div>
				)}
				</div>
				</>
		);
	}
}

// Wrapper component to provide navigate function to class component
function VafFlowWithNavigate(props) {
	const navigate = useNavigate();

	useEffect(() => {
		// A/B testing: randomly redirect to vafFlowVersionB
		const randomNumber = Math.floor(Math.random() * 10) + 1; // Generate number between 1 and 10
		console.log(randomNumber, 'RANDOM NUMBER VAFFLOW');
		if (randomNumber >= 8) {
			// 30% chance (8, 9, or 10) to redirect to version B
			navigate('/company/request/vaf2');
		}
	}, [navigate]);

	return <VafFlow {...props} navigate={navigate} />;
}

export default withTranslation()(
	connect(mapStateToProps, mapDispatchToProps)(VafFlowWithNavigate)
);
